import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ComponentState } from '../../../shared/types/ComponentState';
import { OptionDropdown, SelectControl } from '../../models/OptionDropdownSelect';
import { selectPtrsInfo } from '../../reducers';
import { takeUntil } from 'rxjs/operators';
import { State } from '../../reducers/ptrs-info.reducers';
import { TitleCasePipe } from '@angular/common';
import { DrupalFormService } from '../../../shared/services/DrupalForm.service';
import { FeatureFlagService } from '../../../shared/services/feature-flag-service';
import { AchTransactionDetailsForm, CheckTransactionDetailsForm, ItTransactionDetailsForm, WireTransactionDetailsForm } from '../../models/form/TransactionFormGroup';
const controlName = 'trustPaidFor';
@Component({
  standalone: false,
  selector: 'mm-trust-paid-for',
  templateUrl: './trust-paid-for.component.html',
  styleUrls: ['./trust-paid-for.component.scss']
})
export class TrustPaidForComponent implements OnInit, OnDestroy {
  @Input() parentForm: FormGroup<CheckTransactionDetailsForm | WireTransactionDetailsForm | ItTransactionDetailsForm | AchTransactionDetailsForm >;
  @Input() shouldStyleHorizontal: boolean = false;
  ptrsInfoState$: Observable<ComponentState>;
  noPaidFor: boolean;
  private controlName = 'trustPaidFor';
  paidForDropdownModel$: Observable<SelectControl>
  paidForOptionsIfError = [{
    name: 'Paid For The Trust',
    role: 'Owner',
    id: 0
  }]
  private destroy$ = new Subject<void>();

  constructor(private fb: FormBuilder, private store: Store, private titleCasePipe: TitleCasePipe,
     private drupalFormService: DrupalFormService,
     private featureFlagService: FeatureFlagService) { }

  ngOnInit(): void {
    if (!this.parentForm?.contains(this.controlName)) {
      this.parentForm?.setControl(controlName, this.fb.nonNullable.control('', Validators.required));
    }

    this.ptrsInfoState$ = this.store.select(selectPtrsInfo);

    this.store.select(selectPtrsInfo)
      .pipe(takeUntil(this.destroy$))
      .subscribe((ptrsInfo) => {
        if (ptrsInfo.hasError || ptrsInfo.paidFor.hasError || (!ptrsInfo.paidFor.individuals[0]?.name && !ptrsInfo.loading)) {
          this.noPaidFor = true
        }
      })

    this.paidForDropdownModel$ = this.store.pipe(
      select(selectPtrsInfo),
      map((ptrsInfo) => {
        return {
          title: 'Paid for',
          controlName: this.controlName,
          options: this.mapPaidFor(ptrsInfo),
          validationMessage: 'Paid for needs to be selected'
        };
      }))
  }

  mapPaidFor(ptrsInfo: State): OptionDropdown[] {
    if (ptrsInfo.hasError || ptrsInfo.paidFor.hasError || (!ptrsInfo.paidFor.individuals[0]?.name && !ptrsInfo.loading)) {
      return this.paidForOptionsIfError.map(individual => new OptionDropdown(`${this.titleCasePipe.transform(individual.name)} - ${individual.role}`, `${this.titleCasePipe.transform(individual.name)} - ${individual.role}`))
    }
    else if (ptrsInfo.paidFor.individuals[0]?.name && !ptrsInfo.loading) {
      return ptrsInfo.paidFor.individuals.map(individual => new OptionDropdown(`${this.titleCasePipe.transform(individual.name)} - ${individual.role}`, `${this.titleCasePipe.transform(individual.name)} - ${individual.role}`));
    }
    return []
  }

  ngOnDestroy(): void {
    this.parentForm?.removeControl(controlName);
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  getDrupalPdf(name: string) {
    this.drupalFormService.createDrupalForm(name);
  }
}



